import { Box, Typography, Button, Dialog } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { pxToRem } from '../../utils/getFontValue';
import { useSelector } from 'react-redux';
import { DARK_MODE } from '../../constants';

const BookingUnprocessedOverlay = ({ serialNumber, onClose }) => {
	const themeMode = useSelector((state) => state?.theme?.themeMode);
	const isDark = themeMode === DARK_MODE;

	return (
		<Dialog
			open={true}
			onClose={onClose}
			PaperProps={{
				sx: {
					borderRadius: '16px',
					padding: '2rem 2.5rem',
					minWidth: '360px',
					maxWidth: '480px',
					textAlign: 'center',
					backgroundColor: isDark ? '#1e1e1e' : '#fff',
				},
			}}
		>
			<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
				<CheckCircleOutlineIcon sx={{ fontSize: 64, color: '#619C31' }} />

				<Typography
					sx={{
						fontFamily: "'Uni Neue', sans-serif",
						fontWeight: 700,
						fontSize: pxToRem(20),
						color: isDark ? '#82C1A7' : '#1B681B',
					}}
				>
					Take Out Successful!
				</Typography>

				<Typography
					sx={{
						fontFamily: "'Uni Neue', sans-serif",
						fontWeight: 400,
						fontSize: pxToRem(15),
						color: isDark ? '#ccc' : '#444',
						lineHeight: 1.5,
					}}
				>
					Serial No. / VIN{' '}
					<Box component="span" sx={{ fontWeight: 700 }}>
						{serialNumber}
					</Box>{' '}
					has been taken out.
				</Typography>

				<Button
					variant="contained"
					onClick={onClose}
					sx={{
						mt: 1,
						px: 5,
						py: 1,
						borderRadius: '10px',
						background: 'linear-gradient(90deg, #435C42 0%, #619C31 100%)',
						fontFamily: "'Uni Neue', sans-serif",
						fontWeight: 600,
						fontSize: pxToRem(16),
						color: '#fff',
						textTransform: 'none',
						'&:hover': {
							background: 'linear-gradient(90deg, #2e3f2d 0%, #4a7825 100%)',
						},
					}}
				>
					OK
				</Button>
			</Box>
		</Dialog>
	);
};

export default BookingUnprocessedOverlay;
